import * as React from "react";
function SvgIcArrowUpRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.876 14.962L16.77 7.106 8.914 5l-.195.725 7.02 1.881L5 18.346l.53.53 10.74-10.74 1.88 7.02.726-.194z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcArrowUpRight;
